import React, { useState, useEffect } from "react";
import moment from "moment";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getData } from "../../../../services/library";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import DialogNuevo from "./Observaciones/DialogNuevo";
import SinObs from "./Observaciones/SinObs";

const CC_COLOR = "#ddb07dff";

export default function DialogObservacionesCC(props) {
    const { pedido } = props;
    const [obsCC, setObsCC] = useState([]);

    const noHayObs = !obsCC || obsCC.length === 0;

    useEffect(() => {
        getData(`/gestion/${pedido.idpedido}`, setObsCC);
    }, []);

    const icono = <AccountBalanceIcon sx={{ fontSize: 22 }} />
    
    const children = () =>{
        return (
            <>
            {noHayObs ? (
                        <SinObs/>
                    ) : (
                        obsCC.map((observacion, index) => (
                            <>
                                {!!observacion.observaciones.length && (
                                    <React.Fragment key={index}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: 2,
                                                px: 3,
                                                py: 2,
                                                "&:hover": { bgcolor: "#eeeeee" },
                                                transition: "background-color 0.15s",
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                    pt: 0.25,
                                                }}
                                            >
                                                <Avatar
                                                    sx={{
                                                        bgcolor: CC_COLOR,
                                                        width: 34,
                                                        height: 34,
                                                    }}
                                                >
                                                    <ManageSearchIcon sx={{ fontSize: 24 }} />
                                                </Avatar>
                                            </Box>

                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: 1,
                                                        mb: 0.5,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontWeight: 700,
                                                            color: "#333",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {observacion.usuario}
                                                    </Typography>
                                                    {observacion?.created_at && (
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                color: "#888",
                                                                fontSize: 11,
                                                                whiteSpace: "nowrap",
                                                                flexShrink: 0,
                                                            }}
                                                        >
                                                            {moment(observacion.created_at).format(
                                                                "DD/MM/YYYY HH:mm:ss"
                                                            )}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: "#555",
                                                                lineHeight: 1.5,
                                                                wordBreak: "break-word",
                                                            }}
                                                        >
                                                            {observacion.observaciones}
                                                        </Typography>
                                                {
                                                    observacion.monto && (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                color: "#555",
                                                                lineHeight: 1.5,
                                                                wordBreak: "break-word",
                                                            }}
                                                        >
                                                            Monto a pagar: $ {observacion.monto}
                                                        </Typography>

                                                    )
                                                }
                                            </Box>
                                        </Box>

                                        {index < obsCC.length - 1 && (
                                            <Divider sx={{ mx: 3 }} />
                                        )}
                                    </React.Fragment>
                                )}
                            </>
                        ))
                    )}

            </>
        )
    } 

    return (
        <>
            <DialogNuevo
                pedido={pedido}
                open={props.open}
                handleClose={props.handleClose}
                titulo="Observaciones de Cuentas Corrientes"
                subtitulo={`Pedido #${pedido?.idpedido}`}
                children={children()}
                icono={icono}
            />
        </>
    )
}